//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_GK,
  TITLE_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

//IMPORTING FONT
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import useScrollToHashSection from "../../hooks/useScrollToHashSection";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerSection from "../../components/BannerSection";
import CustomButton from "../../components/CustomButton";
import FooterBar from "../../components/FooterBar";
import { GrLocation } from "react-icons/gr";
import KALogo from "../../assets/logo/logo-KA.png";
import FKLogo from "../../assets/logo/logo-FK.png";
import MKLogo from "../../assets/logo/logo-MK.png";
import KANovoHamburgo from "../../assets/images/assistencial-novo-hamburgo.webp";
import KAEstanciaVelha from "../../assets/images/assistencial-estancia-velha.webp";
import KACampoBom from "../../assets/images/assistencial-campo-bom.webp";
import KADoisIrmaos from "../../assets/images/assistencial-dois-irmaos.webp";
import KAIvoti from "../../assets/images/assistencial-ivoti.webp";
import KASaoLeopoldo from "../../assets/images/assistencial-sao-leopoldo.webp";
import KASapiranga from "../../assets/images/assistencial-sapiranga.webp";
import FKNovoHamburgo from "../../assets/images/funeraria-krause.webp";
import MKNovoHamburgo from "../../assets/images/memorial-krause.webp";
import OndeEstamosBG from "../../assets/images/onde-estamos.webp";
import "./OndeEstamos.css";

export default function OndeEstamos() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useScrollToHashSection();

  return (
    <div className="OndeEstamos">
      <DynamicTitle
        pageTitle="Grupo Krause - Localização"
        pageMeta="Grupo Krause"
        pageContent="Encontre uma das nossas unidades mais próximas a você."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <GrLocation
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"ONDE ESTAMOS"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Encontre uma das nossas unidades mais próximas a você."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={OndeEstamosBG}
        bannerBGmobile={OndeEstamosBG}
      />
      <Container id="assistencial">
        <Row>
          <Col className="location-first-col">
            <img src={KALogo} alt="Logo Krause Assistencial" />
          </Col>
        </Row>
        <Row>
          <Col className="location-second-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Conheça todas as nossas unidades da Krause Assistencial.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KANovoHamburgo}
                alt="Assistencial Novo Hamburgo"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  MATRIZ
                  <br />
                  NOVO HAMBURGO
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Rua Júlio de Castilhos 342 <br />
                  Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/RXmZx63R7uCHh5df7"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KAEstanciaVelha}
                alt="Assistencial Estância Velha"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  ESTÂNCIA VELHA
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Rua Ruy Barbosa, 41, Sala 04
                  <br />
                  Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/11qrDhujPjM6vomB6"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KACampoBom}
                alt="Assistencial Campo Bom"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  CAMPO BOM
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Av. São Leopoldo, 380, Sala 101
                  <br />
                  Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/uaGd26XWFaG3YYAD9"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KADoisIrmaos}
                alt="Assistencial Dois Irmãos"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  DOIS IRMÃOS
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Av. São Miguel 866, Sala 03
                  <br />
                  Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/yZUpAdibQq4B7QWw6"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KAIvoti}
                alt="Assistencial Ivoti"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  IVOTI
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Rua Jacob Schneck, 118, Sala 02
                  <br />
                  Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/NnSE2yLYE2gsKcMUA"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KASaoLeopoldo}
                alt="Assistencial São Leopoldo"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  SÃO LEOPOLDO
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Rua Osvaldo Aranha, 530
                  <br />
                  loja 02 - Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/AUF9eETzvZeQadrr7"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col className="location-second-col">
            <div className="location-card">
              <img
                src={KASapiranga}
                alt="Assistencial Sapiranga"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  SAPIRANGA
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Segunda a Sexta
                  <br /> 8h às 18:30h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Rua Carlos Biehl, 256
                  <br />
                  Centro
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/62J4VmaqCsS8PrJf9"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row id="funerario">
          <Col className="location-third-col">
            <img
              src={FKLogo}
              alt="Logo Funerária Krause"
              className="location-fk-img"
            />
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Conheça a nossa estrutura funerária de excelência
            </p>
            <div className="location-card">
              <img
                src={FKNovoHamburgo}
                alt="Funerária Krause"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  NOVO HAMBURGO
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Todos os dias
                  <br /> 24h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Rua Santos Pedroso, 155
                  <br />
                  Hamburgo Velho
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/et1BLTxVXiU2fyJv8"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
          <Col id="cemiterio" className="location-third-col">
            <img src={MKLogo} alt="Logo Memorial" className="location-fk-img" />
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Conheça a nossa estrutura Memorial completa
            </p>
            <div className="location-card">
              <img
                src={MKNovoHamburgo}
                alt="Funerária Krause"
                className="location-img"
              />
              <div
                style={{ backgroundColor: WHITE }}
                className="location-card-text"
              >
                <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
                  NOVO HAMBURGO
                </h3>
                <p
                  style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}
                  className="location-card-text-bold"
                >
                  Todos os dias
                  <br /> 7h às 19h
                </p>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  R. Helmuth Heldt, 120
                  <br />
                  Canudos
                </p>
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href="https://maps.app.goo.gl/gEkwyqTmjDsdQjqB8"
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="COMO CHEGAR"
                  backgroundColor={PRIMARY_BTN_GK}
                  fontFamily="Unageo-Bold"
                  fontColor={WHITE}
                  fontSize={18}
                  width={180}
                  borderColor={PRIMARY_BTN_GK}
                  disabled={false}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
